import React from "react";

import Motivo from "./Motivo.jsx";


const Mensaje = () => {
    return (
        <ul className="dropdown-menu">
            <li>
                <p>Debe seleccionar usuarios con el mismo estado</p>
            </li>
        </ul>
    );
}

const PantallaBloquear = (props) => {
    return (
        <ul className="dropdown-menu">
            <li>
                <p><b>{props.message} </b></p>
            </li>
            <li>
                <Motivo setMotivoBloqueo={props.setMotivoBloqueo} setUserState={props.setUserState} />
            </li>
        </ul>
    );
}

const BotonBloqueo = (props) => {
    let usuariosSeleccionados;
    let usuariosBloqueados;

    if (props.usuariosFiltrados != undefined) {
        usuariosBloqueados = props.usuariosFiltrados.find(x => x.Bloqueado == true) != undefined ? props.usuariosFiltrados.filter(x => x.Bloqueado == true).length : 0;
    }

    if (props.usuariosFiltrados != undefined) {
        usuariosSeleccionados = props.usuariosFiltrados.find(x => x.Seleccionado == true) != undefined ? props.usuariosFiltrados.filter(x => x.Seleccionado == true).length : 0;
    }

    let message = usuariosSeleccionados > 1 ? usuariosSeleccionados + ' usuarios fueron bloqueados' :
        usuariosSeleccionados == 1 ? usuariosSeleccionados + ' usuario fue bloqueado' : "";

    let Bloqueados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Bloqueado == true).length;

    return (
        <div className="dropdown">
            <button className="btn btn-icon btn-blocked" title="Bloquear los seleccionados" data-toggle="dropdown"
                disabled={!(usuariosSeleccionados > 0)}>
                <span className="ti-lock"></span>
            </button>
            {(Bloqueados >= 1) ? <Mensaje />: <PantallaBloquear setMotivoBloqueo={props.setMotivoBloqueo} message={message} setUserState={props.setUserState} />}
        </div>
    );
}

export default BotonBloqueo;